var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardingIcMore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "7px",
    viewBox: "0 0 23 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "onboardingIcMore") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.376893,75.064452 C136.7425,75.064452 135.417563,73.7955191 135.417563,72.230211 C135.417563,70.6649029 136.7425,69.3959699 138.376893,69.3959699 C140.011285,69.3959699 141.336222,70.6649029 141.336222,72.230211 C141.336222,73.7955191 140.011285,75.064452 138.376893,75.064452 Z M138.376893,83.0003268 C136.7425,83.0003268 135.417563,81.7313939 135.417563,80.1660858 C135.417563,78.6007777 136.7425,77.3318448 138.376893,77.3318448 C140.011285,77.3318448 141.336222,78.6007777 141.336222,80.1660858 C141.336222,81.7313939 140.011285,83.0003268 138.376893,83.0003268 Z M138.376893,90.9362017 C136.7425,90.9362017 135.417563,89.6672688 135.417563,88.1019607 C135.417563,86.5366526 136.7425,85.2677197 138.376893,85.2677197 C140.011285,85.2677197 141.336222,86.5366526 141.336222,88.1019607 C141.336222,89.6672688 140.011285,90.9362017 138.376893,90.9362017 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Copy-4",
    transform: "translate(-127.000000, -77.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "onboardingIcMore",
    fill: "#333333",
    transform: "translate(138.376893, 80.166086) scale(-1, -1) rotate(-90.000000) translate(-138.376893, -80.166086) ",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingIcMore);
export default __webpack_public_path__ + "static/media/onboardingIcMore.cc906cf2c66981a7a96a6e5cb6eba4de.svg";
export { ForwardRef as ReactComponent };